/* unplugin-vue-components disabled */import script from "./indexjgyt.vue?vue&type=script&setup=true&lang=js"
export * from "./indexjgyt.vue?vue&type=script&setup=true&lang=js"

import "./indexjgyt.vue?vue&type=style&index=0&id=174f5ce5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-174f5ce5"]])

export default __exports__